import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../_actions/chapterActions";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Typography
} from "@material-ui/core";
import Button from "components/CustomButtons/Button";

const useStyles = makeStyles(theme => ({
  dialogActions: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2)
  }
}));

const HelpDialog = props => {
  const classes = useStyles();

  const { data, open, onClose, getHelpTextByType, helpText } = props;

  const [helpTextTitle, setHelpTextTitle] = useState("");
  const [helpTextContent, setHelpTextContent] = useState("");

  useEffect(() => {
    setHelpTextTitle(helpText?.name);
    setHelpTextContent(helpText?.text);
  }, [helpText]);

  useEffect(() => {
    if (
      data !== undefined &&
      data.type !== undefined &&
      data.type > 0 &&
      data.subType !== undefined &&
      data.subType > 0
    ) {
      setHelpTextTitle("");
      setHelpTextContent("");
      getHelpTextByType(data.type, data.subType);
    }
  }, [data]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Help</DialogTitle>
      <DialogContent>
        <Typography>
          <strong>{helpTextTitle}</strong>
        </Typography>
        <br />
        <div dangerouslySetInnerHTML={{ __html: helpTextContent }}></div>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button color="success" variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  isLoading: state.chapterReducer.isLoading,
  helpText: state.chapterReducer.helpText,
  isFetching: state.chapterReducer.isFetching,
  isFetched: state.chapterReducer.isFetched
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...actionCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HelpDialog);
